.container {
  width: 100%;
  position: relative;
  aspect-ratio: 16 / 9;

  #action {
    background: transparent;
    border: none;
    & div {
      svg {
        fill: var(--color-grey-4);
        height: 1.6rem;
        background-color: transparent;
      }
    }

    #select-text {
      padding-left: 0.8rem;
      background-color: var(--color-grey-8);
      color: var(--color-grey-2);
    }

    #option-menu {
      background-color: var(--color-grey-8);
      color: var(--color-grey-2);
    }

    #delete-button {
      background-color: var(--color-grey-8);
      color: var(--color-grey-2);
      opacity: 1;

      & > svg {
        fill: var(--color-grey-2);
        height: 1.6rem;
        width: 1.6rem;
        background-color: transparent;
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }
}
